export var ImageResizeMode;
(function (ImageResizeMode) {
    ImageResizeMode["Crop"] = "crop";
    ImageResizeMode["Fit"] = "fit";
})(ImageResizeMode || (ImageResizeMode = {}));
//# sourceMappingURL=imageResizeMode.js.map